module.exports = __webpack_public_path__ + "img/press-hero.9664c701.jpg";